import { Theme } from '@mui/material';
import { Colors } from '../../../utils/theme';

export const getNewsletterSectionStyles = (theme: Theme) => ({
	root: {
		backgroundColor: Colors['FFF521'],
		py: { xs: '50px', sm: '60px', md: '80px', lg: '100px' },
		gap: { xs: '18px', sm: '22px', md: '26px', lg: '30px', xl: '32px' },
		px: '10px',
	},
	titleRow: {
		gap: { xs: '20px', sm: '30px', md: '35px', xl: '40px' },
	},
	titleBold: {
		fontFamily: 'Integral CF',
		fontSize: { xs: '40px', sm: '50px', md: '60px', lg: '70px', xl: '80px' },
		lineHeight: '1.31',
		color: Colors['120E0D'],
	},
	titleItalic: {
		fontFamily: 'Integral CF',
		fontSize: { xs: '40px', sm: '50px', md: '60px', lg: '70px', xl: '80px' },
		lineHeight: '1.2',
		fontStyle: 'italic',
		color: Colors['120E0D'],
	},
	subtitle: {
		fontFamily: 'Integral CF',
		fontStyle: 'italic',
		fontWeight: 500,
		fontSize: { xs: '10px', md: '12px', lg: '14px' },
		lineHeight: '1.48',
		textAlign: 'center',
	},
	inputs: {
		gap: { xs: '10px', sm: '15px', md: '20px', lg: '25px', xl: '30px' },
	},
	textField: {
		'& .MuiInput-input': {
			fontFamily: 'Montserrat',
			fontWeight: '600',
			fontSize: '14px',
			color: Colors['120E0D'],
		},

		'& .MuiInput-input::placeholder': {
			opacity: 1,
			fontFamily: 'Integral CF',
			fontWeight: '400',
			fontSize: '12px',
			color: Colors['120E0D'],
			textTransform: 'uppercase',
		},
	},
	subscribeButton: {
		backgroundColor: 'white',

		'&:hover': {
			color: 'white',
			backgroundColor: Colors['321AF1'],
		},
	},
});
